import moment from "moment";
import "moment/locale/pt-br";
import { conexaoDB } from "./db";
import store from "@/store";
import { isMobileMq } from "@/global";

export const DB_CFG_VISITA = "vt-config";
export const DB_PROD_VISITA = "vt-produtores";
export const DB_VISITAS = "vt-visitas";
export const DB_SYNC = "vt-sinc";
export const DB_DOCS = "vt-docs"

/* utilzinho pra encapsular tx */
function withTx(db, storeName, mode, fn) {
    return new Promise((resolve, reject) => {
        const tx = db.transaction([storeName], mode);
        const store = tx.objectStore(storeName);
        Promise.resolve(fn(store, tx))
            .then(() => {
                tx.oncomplete = () => resolve(true);
                tx.onerror = e => reject(tx.error || e?.target?.error);
                tx.onabort = e => reject(tx.error || e?.target?.error);
            })
            .catch(reject);
    });
}

/* salva um único objeto, limpando antes */
async function saveObjectVT_DB(DB_SELECT, data) {

    if (!isMobileMq()) return

    const db = await conexaoDB();
    return withTx(db, DB_SELECT, "readwrite", (store) => {
        return new Promise((res, rej) => {
            const clearReq = store.clear();
            clearReq.onsuccess = () => {
                const addReq = store.add(data);
                addReq.onsuccess = () => res(true);
                addReq.onerror = e => rej(e.target.error);
            };
            clearReq.onerror = e => rej(e.target.error);
        });
    });
}

async function saveArrayVT_DB(DB_SELECT, data) {
    if (!isMobileMq()) return;

    const db = await conexaoDB();
    return withTx(db, DB_SELECT, "readwrite", (store) => {
        return new Promise((resolve, reject) => {

            // usando uma IIFE assíncrona
            (async () => {
                try {

                    // CASO NORMAL (não é visitas)
                    if (DB_SELECT !== DB_VISITAS) {
                        await new Promise((res, rej) => {
                            const clearReq = store.clear();
                            clearReq.onsuccess = () => res(true);
                            clearReq.onerror = e => rej(e.target.error);
                        });

                        for (const d of data) {
                            await new Promise((res, rej) => {
                                var req
                                if (DB_SELECT == DB_DOCS) {
                                    req = store.add(d, d.id);
                                } else {
                                    req = store.add(d);
                                }

                                req.onsuccess = () => res(true);
                                req.onerror = e => rej(e.target.error);
                            });
                        }

                        resolve(true);
                        return;
                    }

                    // 🔥 CASO ESPECÍFICO: DB_VISITAS

                    // 1) Buscar chaves existentes
                    const keys = await new Promise((res, rej) => {
                        const req = store.getAllKeys();
                        req.onsuccess = e => res(e.target.result || []);
                        req.onerror = e => rej(e.target.error);
                    });

                    // 2) Remover somente registros sincronizados
                    for (const key of keys) {
                        const registro = await new Promise((res, rej) => {
                            const req = store.get(key);
                            req.onsuccess = e => res(e.target.result);
                            req.onerror = e => rej(e.target.error);
                        });

                        if (
                            registro &&
                            (registro.criado_offline === false &&
                                registro.atualizar === false) ||
                            registro.id == 0
                        ) {
                            await new Promise((res, rej) => {
                                const req = store.delete(key);
                                req.onsuccess = () => res(true);
                                req.onerror = e => rej(e.target.error);
                            });
                        }
                    }

                    // 3) Inserir registros vindos da API
                    for (const d of data) {
                        await new Promise((res, rej) => {
                            const req = store.put(d, d.id); // usa ID do backend
                            req.onsuccess = () => res(true);
                            req.onerror = e => rej(e.target.error);
                        });
                    }

                    resolve(true);

                } catch (err) {
                    reject(err);
                }

            })(); // fim da IIFE
        });
    });
}



/* obtém todos */
async function getDataVT_DB(DB_SELECT) {

    if (!isMobileMq()) return []

    const db = await conexaoDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction([DB_SELECT], "readonly");
        const store = tx.objectStore(DB_SELECT);
        const req = store.getAll();
        req.onsuccess = (e) => {
            // structuredClone quando disponível; JSON é ok também
            resolve(JSON.parse(JSON.stringify(e.target.result || [])));
        };
        req.onerror = e => reject(e.target.error);
    });
}

/* cria uma visita (offline), define campos derivados e grava */
async function createVT_DB(visita) {

    if (!isMobileMq()) return

    const db = await conexaoDB();
    moment.locale("pt-br");
    return new Promise((resolve, reject) => {
        const tx = db.transaction([DB_VISITAS], "readwrite");
        const objStore = tx.objectStore(DB_VISITAS);
        var addReq
        if (navigator.onLine)
            addReq = objStore.add(visita, visita.id);
        else
            addReq = objStore.add(visita);
        addReq.onsuccess = (e) => {
            if (!navigator.onLine) {
                const pk = e.target.result;

                // preenche PKs locais
                visita.id = pk;
                visita.status = "PENDENTE";
                visita.criado_offline = true

                // usa Vuex como você já fazia
                const prod2 = store.state.visitaTecnica.produtores.lista.find(
                    (p) => p.matr == visita.matricula
                );
                if (prod2) {
                    visita.nome_produtor = prod2.nome;
                    visita.cidade = prod2.cidade;
                    visita.uf = prod2.uf;
                }

                visita.permite_deletar = true;

                // formatação de datas com formato explícito
                const mDataVisita = moment(visita.data_visita, "DD/MM/YYYY HH:mm:ss", true);
                const dataOk = mDataVisita.isValid() ? mDataVisita : moment(visita.data_visita);

                visita.dia_visita = dataOk.format("DD");
                visita.mes_visita = dataOk.format("MMM");

                visita.data_hora_max_edicao = moment()
                    .add(24, "hours")
                    .toISOString(); // ex: 2025-11-13T10:37:58.852Z

                // agora atualiza o registro com os campos derivados
                const putReq = objStore.put(visita, pk);

                putReq.onsuccess = () => resolve(pk);
                putReq.onerror = (err) => reject(err.target.error);
            } else {
                resolve(true)
            }
        };

        addReq.onerror = (e) => reject(e.target.error);

        tx.onerror = (e) => reject(tx.error || e?.target?.error);
    });
}


async function updateVT_DB(DB_SELECT, keyOrData, maybeNewData) {

    if (!isMobileMq()) return

    const db = await conexaoDB();

    let key = keyOrData;
    let newData = maybeNewData;

    return new Promise((resolve, reject) => {
        const tx = db.transaction([DB_SELECT], "readwrite");
        const store = tx.objectStore(DB_SELECT);

        const finishPut = (pk) => {
            // CASO 1: pk == 0 → queremos criar um novo registro e fazer o objeto
            // gravado já ter o campo id.
            if (pk === 0) {
                const addReq = store.add(newData);

                addReq.onsuccess = (e) => {
                    const generatedKey = 10000000 + e.target.result;

                    // 🔥 Aqui você coloca o id no objeto
                    newData.id = generatedKey;                    

                    // Agora faz um PUT pra atualizar o registro armazenado
                    store.delete(e.target.result)
                    const putReq = store.put(newData, generatedKey);                    
                    putReq.onsuccess = () => resolve(generatedKey);
                    putReq.onerror = (err) => reject(err.target.error);
                };

                addReq.onerror = (e) => reject(e.target.error);
                return;
            }

            // CASO 2: pk != 0 → só atualiza o registro existente
            const req = store.put(newData, pk);
            req.onsuccess = () => resolve(pk);
            req.onerror = (e) => reject(e.target.error);
        };

        if (key !== null && key !== undefined) {            
            finishPut(key);
            return;
        }
        // caso 3: não sei como atualizar
        resolve(false);
    });
}

async function deleteByKeyVT_DB(DB_SELECT, key) {

    if (!isMobileMq()) return

    const db = await conexaoDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction([DB_SELECT], "readwrite");
        const store = tx.objectStore(DB_SELECT);
        const req = store.delete(key);
        req.onsuccess = () => resolve(true);
        req.onerror = (e) => reject(e.target.error);
        tx.onerror = (e) => reject(e.target.error);
    });
}

async function getDataByKeyVT_DB(DB_SELECT, key) {

    if (!isMobileMq()) return null;

    const db = await conexaoDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction([DB_SELECT], "readonly");
        const store = tx.objectStore(DB_SELECT);
        const req = store.get(key);

        req.onsuccess = (e) => {
            resolve(
                JSON.parse(JSON.stringify(e.target.result || null))
            );
        };

        req.onerror = e => reject(e.target.error);
    });
}

export {
    saveObjectVT_DB,
    saveArrayVT_DB,
    getDataVT_DB,
    createVT_DB,
    deleteByKeyVT_DB,
    updateVT_DB,
    getDataByKeyVT_DB
};
